/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DeviceManufacurer from './device-manufacurer';
import DeviceManufacurerDetail from './device-manufacurer-detail';
import DeviceManufacurerUpdate from './device-manufacurer-update';
import DeviceManufacurerDeleteDialog from './device-manufacurer-delete-dialog';

const DeviceManufacurerRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DeviceManufacurer />} />
    <Route path="new" element={<DeviceManufacurerUpdate />} />
    <Route path=":id">
      <Route index element={<DeviceManufacurerDetail />} />
      <Route path="edit" element={<DeviceManufacurerUpdate />} />
      <Route path="delete" element={<DeviceManufacurerDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DeviceManufacurerRoutes;
